import request from "../utils/request";

export function GET_PerformanceTeam(token, payload) {
  return request.get("/Performance/Team", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_PerformanceReport(token, payload) {
  return request.get("/Performance/Report", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_PerformanceSnapshot(token, payload) {
  return request.post("/Performance/Snapshot", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}
